/**
 *
 * PreloadState
 *
 */
import * as React from 'react';
import { usePreloadStateSlice, preloadStateActions } from './slice';
import { useSelector, useDispatch } from 'react-redux';
import { selectPreloadState } from './slice/selectors';
import { useAuth0 } from '@auth0/auth0-react';
import _ from 'lodash';
import { ActionCreatorWithoutPayload } from '@reduxjs/toolkit';
import logger from '../../../utils/logger';

function useFetchSinglePreloadState(
  isAuthenticated: boolean,
  isTokenSet: boolean,
  isError: boolean,
  curData: any,
  action: ActionCreatorWithoutPayload<string>,
  type: string,
) {
  const dispatch = useDispatch();
  React.useEffect(() => {
    if (isAuthenticated && isTokenSet) {
      if (isError) {
        //TODO:Dispatch toaster
        logger.error({ message: `Fetch ${type} error` });
        return;
      }

      if (!curData) {
        dispatch(action());
      }
    }
  }, [type, isError, curData, dispatch, isAuthenticated, isTokenSet, action]);
}

export function usePreloadState(isTokenSet: boolean) {
  const {
    actions: {
      fetchUserRole,
      fetchUserSegment,
      fetchUserMetaDataTypes,
      fetchSubAddon,
      fetchSubPlanType,
      fetchCompanySsoConnectionType,
      cleanup,
    },
  } = usePreloadStateSlice();

  const state = useSelector(selectPreloadState, _.isEqual);

  const roleErr = state?.userRole?.error;
  const roleData = state?.userRole?.data;

  const segmentErr = state?.userSegment?.error;
  const segmentData = state?.userSegment?.data;

  const metaErr = state?.userMetaData?.error;
  const metaData = state?.userMetaData?.data;

  const subAddonErr = state?.subAddon?.error;
  const subAddon = state?.subAddon?.data;

  const subPlanTypeErr = state?.subPlanType?.error;
  const subPlanType = state?.subPlanType?.data;

  const ssoConnectionTypeErr = state?.companySsoConnectionType?.error;
  const ssoConnectionType = state?.companySsoConnectionType?.data;

  const { isAuthenticated } = useAuth0();
  const dispatch = useDispatch();

  useFetchSinglePreloadState(
    isAuthenticated,
    isTokenSet,
    roleErr,
    roleData,
    fetchUserRole,
    'role',
  );

  useFetchSinglePreloadState(
    isAuthenticated,
    isTokenSet,
    segmentErr,
    segmentData,
    fetchUserSegment,
    'segment',
  );

  useFetchSinglePreloadState(
    isAuthenticated,
    isTokenSet,
    metaErr,
    metaData,
    fetchUserMetaDataTypes,
    'metaDataTypes',
  );

  useFetchSinglePreloadState(
    isAuthenticated,
    isTokenSet,
    subAddonErr,
    subAddon,
    fetchSubAddon,
    'subscription addonss',
  );

  useFetchSinglePreloadState(
    isAuthenticated,
    isTokenSet,
    subPlanTypeErr,
    subPlanType,
    fetchSubPlanType,
    'subscription plan type',
  );

  useFetchSinglePreloadState(
    isAuthenticated,
    isTokenSet,
    ssoConnectionTypeErr,
    ssoConnectionType,
    fetchCompanySsoConnectionType,
    'sso connection type',
  );

  React.useEffect(() => {
    return () => {
      dispatch(preloadStateActions.cleanup());
    };
  }, [dispatch, cleanup]);
  return null;
}
